const ServerURL = "https://geekers.onrender.com/api";
// const ServerURL = "http://localhost:8000/api";

export default ServerURL;
